export default __webpack_public_path__ + "static/media/element_spec_16.acdaeb75.webp";